import React from "react";
import {ViewAcademy, ThinTitle, TextAca, CardMapAcademy, Doubles, ViewCardList, DescriptionAca} from "./AcademyStyles";
import {Content} from "../../../styles/GlobalStyles";
import Color from "../../../assets/Colors";
import {ActionBio} from "../../course_details/components/FacilitadorStyle";
import {TextDescription} from "../../../styles/Products";
import parse from "html-react-parser";
import {isMobile} from "../../../constants/Helpers";

export default function MultiCards({dataF, dataI}) {
   return (
      <ViewAcademy className="noPadding">
         <Content>
            <Doubles>
               <span id="facilitadores" />
               <ViewCardList className="alignContent" style={{position: "relative"}}>
                  <div
                     className="experienceImg"
                     style={{
                        backgroundImage: `url(http://domecqapi.trebolbit.com/${
                           isMobile ? dataF.pathImageWebMobile : dataF.pathImageWebDesktop
                        })`,
                     }}
                  ></div>
                  <CardMapAcademy className="hasIcon">
                     <img src={require("../../../assets/icons/coach_circle.png")} alt="experience" className="iconCard" width="100%" />
                     <ThinTitle color={Color.primary}>EQUIPO DE FACILITADORES</ThinTitle>
                     {/*   <DescriptionAca>
                        Nuestros instructores y facilitadores son altamente reconocidos en el medio y están listos para compartir su
                        experiencia contigo.
                     </DescriptionAca> */}
                     <DescriptionAca>{parse(dataF.description)}</DescriptionAca>
                     <ActionBio to="/Facilitadores">
                        Conoce a nuestros expertos
                        <span>
                           <img src={require("../../../assets/icons/circle_arrow.png")} alt="next" className="mediaIcon" />
                        </span>
                     </ActionBio>
                  </CardMapAcademy>
               </ViewCardList>
               <span id="instalaciones" />
               <ViewCardList>
                  <div
                     className="experienceImg"
                     style={{
                        backgroundImage: `url(http://domecqapi.trebolbit.com/${
                           isMobile ? dataI.pathImageWebMobile : dataI.pathImageWebDesktop
                        })`,
                     }}
                  >
                     {/* <img src=} alt="experience" className="" width="100%" /> */}
                  </div>
                  <CardMapAcademy className="hasIcon">
                     <img
                        src={require("../../../assets/icons/acerca/instalaciones_icon.png")}
                        alt="experience"
                        className="iconCard"
                        width="100%"
                     />
                     <ThinTitle color={Color.primary}>NUESTRAS INSTALACIONES</ThinTitle>
                     {/* <DescriptionAca>
                        Domecq Academy cuenta con equipamiento de primer nivel, la materia prima y producto necesario para que tu
                        experiencia de aprendizaje sea única.
                     </DescriptionAca> */}
                     <DescriptionAca>{parse(dataI.description)}</DescriptionAca>
                     <ActionBio as="div" className="disable">
                        Conoce a nuestros expertos
                        <span>
                           <img src={require("../../../assets/icons/circle_arrow.png")} alt="next" className="mediaIcon" />
                        </span>
                     </ActionBio>
                  </CardMapAcademy>
               </ViewCardList>
            </Doubles>
         </Content>
      </ViewAcademy>
   );
}

MultiCards.defaultProps = {
   dataF: {
      description: "",
   },
   dataI: {
      description: "",
   },
};
